// extracted by mini-css-extract-plugin
module.exports = {"blue":"FantasyTournaments_blue__1BLfj"};